import React, { useState, useCallback } from 'react';
import ExcelUploader from './components/ExcelUploader';
import DataPreview from './components/DataPreview';
import LabelPreview from './components/LabelPreview';
import PrintControls from './components/PrintControls';
import { PersonData, LabelFormat } from './types';
import './App.css';

function App() {
  const [data, setData] = useState<PersonData[]>([]);
  const [selectedFormat, setSelectedFormat] = useState<LabelFormat>('65-1');

  const handleDataLoad = useCallback((loadedData: PersonData[]) => {
    setData(loadedData);
  }, []);

  const handleFormatChange = useCallback((format: LabelFormat) => {
    setSelectedFormat(format);
  }, []);

  return (
    <div className="app">
      <header className="app-header no-print">
        <h1>Generator nalepnica iz excel fajla</h1>
        <p>Učitajte Excel fajl i kreirajte nalepnice za štampanje</p>
      </header>

      <main className="app-main">
        <div className="no-print">
          <section className="upload-section">
            <ExcelUploader onDataLoad={handleDataLoad} />
          </section>

          {data.length > 0 && (
            <>
              <section className="preview-section">
                <DataPreview data={data} />
              </section>

              <section className="controls-section">
                <PrintControls
                  selectedFormat={selectedFormat}
                  onFormatChange={handleFormatChange}
                  dataCount={data.length}
                />
              </section>
            </>
          )}
        </div>

        {data.length > 0 && (
          <section className="labels-section">
            <LabelPreview
              data={data}
              format={selectedFormat}
            />
          </section>
        )}
      </main>
    </div>
  );
}

export default App; 